import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const GiftCard = (props: IconProps) => (
  <Icon width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.9116 10.6328L0.774414 14.4841V4.58983L13.9116 0.738525V10.6328Z"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.7133 4.58981H0.774414V14.4841H16.7133V4.58981Z"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.26367 4.58981V14.4841"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.712891 7.99047H16.7124"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.39552 10.2675L7.52385 9.53697L5.76372 7.99046C5.76372 7.99046 6.80174 8.28492 7.43374 8.33001C8.06574 8.37509 7.93027 7.42868 7.43374 6.57263C6.93721 5.71659 5.26319 7.61162 5.26319 7.61162C5.26319 7.61162 3.66531 5.71639 3.16877 6.57263C2.67224 7.42888 2.53697 8.37509 3.16877 8.33001C3.80058 8.28492 4.83879 7.99046 4.83879 7.99046L3.07866 9.53697L4.20699 10.2675L5.26339 8.30886L6.39592 10.2675H6.39552Z"
      stroke="#131818"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
